import { Map } from 'immutable';
export const PRODUCT = 'product';
export const PRODUCT_OPTIONS_GROUPS = 'productOptionsGroups';
export const IS_FETCHING_ITEM_OPTIONS = 'isFetchingItemOptions';
export const DEEP_LINK = 'deeplink';

const ModuleStateModel = Map({
  [PRODUCT]: null,
  [IS_FETCHING_ITEM_OPTIONS]: false,
  [PRODUCT_OPTIONS_GROUPS]: null,
  [DEEP_LINK]: null,
});

export default ModuleStateModel;
